import { ChartDonut } from 'common/components/charts'

import { styled } from '@mui/material'

export const Donut = styled(ChartDonut)({
  maxWidth: '420px',
})
